export default __webpack_public_path__ + "static/media/office-building-blue.2cddd8a1.svg";